<div class="resource-list__container">
    {#if loadInProgress}
        <LoadingState />
    {:else}
        {#if resources && resources.length > 0}
            <List>
                <thead slot="header">
                    <ListElement header>
                        <CheckboxCell
                            header
                            text={i18n.selectAll}
                            bind:checked={isAllSelected}
                            on:change={(e) => checkedAllResourcesChanged(e.detail)}
                        />
                        <IconCell header />
                        <TextCell header text={i18n.resources_Header} />
                    </ListElement>
                </thead>
                <tbody slot="body">
                    {#each resources as resource}
                        <ListElement>
                            <CheckboxCell
                                text={resource.title}
                                on:change={() => checkedResourcesChanged(resource)}
                                bind:checked={resource.checked}
                            />
                            <IconCell src={resource.iconUrl} text={resource.title} />
                            <TextCell text={resource.title} />
                        </ListElement>
                    {/each}
                </tbody>
            </List>
        {:else}
            <EmptyState iconName="files" title={i18n.noResources} showButton={false} />
        {/if}
    {/if}
</div>

<script>
    import List from "@itslearning/prometheus/assets/lists/List/v1/List.svelte";
    import ListElement from "@itslearning/prometheus/assets/lists/ListElement/v1/ListElement.svelte";
    import TextCell from "@itslearning/prometheus/assets/lists/TextCell/v1/TextCell.svelte";
    import IconCell from "@itslearning/prometheus/assets/lists/IconCell/v1/IconCell.svelte";
    import CheckboxCell from "@itslearning/prometheus/assets/lists/CheckboxCell/v1/CheckboxCell.svelte";
    import EmptyState from "@itslearning/prometheus/assets/nodes/EmptyState/v1/EmptyState.svelte";
    import LoadingState from "@its-ui/common-components/LoadingState/LoadingState.svelte";

    export let i18n;
    export let resources;
    export let selectedResources = [];
    export let loadInProgress;
    export let isAllSelected = false;

    async function checkedResourcesChanged(resource) {
        isAllSelected = resources.length > 0 && resources.every(
            (resource) => resource.checked
        );
        updateSelectedResources(resource);
    }

    async function checkedAllResourcesChanged({ checked }) {
        resources.forEach((resource) => {
            resource.checked = checked;
            updateSelectedResources(resource);
        });

        resources = resources;
    }

    function updateSelectedResources(resource) {
        if (resource.checked && !selectedResources.includes(resource.id)) {
            selectedResources.push(resource.id);
            selectedResources = selectedResources;
        } else if (!resource.checked && selectedResources.includes(resource.id)) {
            selectedResources = selectedResources
                .filter(id => id !== resource.id);
        }
    }
</script>
